'use strict';

// import deepExtend from './deepExtend.js';
// import closestParent from './closestParent.js';
// import debounce from './debounce.js';
import throttle from './throttle.js';
import mapRange from './mapRange.js';
import closestParent from './closestParent.js';

const getWindowHeight = function () {
    return window.innerHeight || document.documentElement.clientHeight;
};

const isInViewport = function (elem) {
    const bounding = elem.getBoundingClientRect();

    const fromTop = bounding.top + bounding.height >= 0;
    const fromBottom = bounding.bottom - bounding.height <= getWindowHeight();
    const inView = fromTop && fromBottom;

    return inView;
};

const getItemImageOffset = function (item) {
    const topThreshold = 0.0625;
    const bottomThreshold = 0.125;
    const itemBounding = item.container.getBoundingClientRect();
    const imageBounding = item.image.getBoundingClientRect();
    const windowHeight = getWindowHeight();
    let offset = mapRange(
        windowHeight - itemBounding.top,
        0,
        windowHeight + itemBounding.height,
        0 - topThreshold,
        1 + bottomThreshold
    );
    offset = Math.min(Math.max(offset, 0), 1);
    offset = getTime(offset);
    return [offset * -100, offset * itemBounding.height];
};

const applyImageOffset = function (item) {
    if (isInViewport(item.container)) {
        item.container.classList.add('w-is-in-viewport');
        if (!!item.seen) item.container.classList.add('w-is-seen');

        const offset = getItemImageOffset(item);
        item.image.style.transform =
            'translate3d(0, ' +
            offset[0] +
            '%, 0) translateY(' +
            offset[1] +
            'px)';
    } else {
        item.container.classList.remove('w-is-in-viewport');
    }
};

const ease = function (t, b, c, d) {
    if ((t /= d / 2) < 1) {
        return (c / 2) * t * t + b;
    } else {
        return (-c / 2) * (--t * (t - 2) - 1) + b;
    }
};

const getTime = function (score) {
    const maxTime = 0,
        minTime = 1,
        maxScore = 1;
    return (
        maxTime + minTime - ease(score, minTime, maxTime - minTime, maxScore)
    );
};

export default class ParallaxHandler {
    constructor() {
        this.previous = false;
        this.active = true;

        this.init();

        const update = () => {
            const current = Math.round(window.pageYOffset);
            // Avoid calculations if not needed
            if (this.active !== true || this.previous === current) {
                requestAnimationFrame(update);
                return false;
            } else {
                this.items.forEach(function (item) {
                    applyImageOffset(item);
                });
                this.previous = current;
                requestAnimationFrame(update);
            }
        };
        update();

        window.addEventListener(
            'resize',
            throttle(() => {
                this.previous = false;
            }).bind(this)
        );
    }

    init() {
        this.items = [];
        const items = document.querySelectorAll('.w-scroll-mockup__container');

        items.forEach((item) => {
            const image = item.querySelector('img');
            if (image) {
                const object = {
                    container: item,
                    image,
                    seen: true,
                    factor: -1,
                };

                const loaded = () => {
                    object.container.classList.add('w-is-loaded');
                };

                applyImageOffset(object);

                if (object.image.complete) {
                    loaded();
                } else {
                    object.image.addEventListener('load', loaded);
                    object.image.addEventListener('error', function () {
                        console.log('Image not loaded...');
                    });
                }

                this.items.push(object);
            }
        });
    }

    forceUpdate() {
        this.active = true;
        this.previous = false;
    }
}
